module.exports = "/_next/static/images/ac6d27768400595d3639524268d36328-hero-lg.jpg";